import { isOfflineFeatureEnabled } from "./featurePolicy";
export const OFFLINE_GAMES_ENABLED = isOfflineFeatureEnabled(import.meta.env,
 typeof location === "undefined" ? "" : location.hostname);
